export const WASTE_NAME_LABEL = "Dénomination usuelle";
